import { Button } from "components/Button";
import { Header } from "components/Header";
import { InputFormField } from "components/InputFormField";
import { Loading } from "components/Loading";
import { PlaceHolderNotExists } from "components/PlaceholderNotExists";
import { TableModifiedCards } from "components/TableModified/TableModifiedCards";
import { TableModifiedFilters } from "components/TableModified/TableModifiedFilters";
import { TableModifiedPagination } from "components/TableModified/TableModifiedPagination";
import { TableModifiedTable } from "components/TableModified/TableModifiedTable";
import React from "react";
import { Container, TableSearchUsers } from "./styles";
import { useSellersTable } from "./useSellersTable";

const tableHead = ["Seller ID", "CNPJ", "Nome Fantasia", "Nota", "Selo", "Ativo", "Verificado", "Integrado", " "];

export const SellersTable: React.FC = () => {
  const {
    loading,
    error,
    properties,
    sellerRows,
    sellersCount,
    searchText,
    tableFilters,
    searchTextFormRef,
    pageNumber,
    sellersPerPage,
    handleSearchTextFormSubmit,
    handleFilterChange,
    handleFilterRemove,
    handleSearchTextRemove,
    handlePageSelected,
    handleRowsPerPageChange,
  } = useSellersTable();

  return (
    <Container>
      <Header>
        <TableSearchUsers
          className="table-search-user"
          onSubmit={handleSearchTextFormSubmit}
          ref={searchTextFormRef}
        >
          <InputFormField 
            label="Buscar Varejistas" 
            autoFocus={true} 
            name="searchText" 
            marginBotton={"0"} 
            backGround={"white"} 
            defaultValue={searchText}
            block={true} 
          />
          <Button 
            label="Buscar" 
            typeBtn="blue"
            type="submit"
            block={false} 
          />
        </TableSearchUsers>
      </Header>
      <TableModifiedFilters
        filters={tableFilters}
        searchTextFilter={searchText}
        onFilterChange={handleFilterChange}
        onFilterRemove={handleFilterRemove}
        onSearchTextRemove={handleSearchTextRemove}
      />
      {
        loading
        ? <Loading/>
        : error
          ? <PlaceHolderNotExists title="Erro ao se comunicar com o servidor"/>
          : <>
              <TableModifiedCards
                properties={properties}
              />
              <TableModifiedTable
                headerColumns={tableHead}
                rows={sellerRows}
              />
            </>
      }
      {
        sellersCount > 0
        ? <TableModifiedPagination
            totalItemsCount={sellersCount}
            pageNumber={pageNumber}
            rowsPerPage={sellersPerPage}
            onPageSelected={handlePageSelected}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        : null
      }
    </Container>
  );
}